import React from 'react';
import styled from '../../../libs/styled.es.js';
import { space } from 'styled-system';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledCheckbox = styled.div(space, ({ theme, checked, circle, indeterminate = false, width, height }) => {
  const checkedColor = checked || indeterminate ? theme.brand.primary : "#BCBFD6";
  const styles = {
    width,
    height,
    border: circle || !checked ? `1px solid ${checkedColor}` : "none",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    overflow: "hidden"
  };
  if (circle) {
    styles.borderRadius = "50% !important";
  }
  if (checked || indeterminate) {
    styles["&:after"] = {
      content: '" "',
      width: `calc(${width} - ${circle || indeterminate ? 6 : 0}px)`,
      height: `calc(${height} - ${circle || indeterminate ? 6 : 0}px)`,
      backgroundColor: checkedColor,
      borderRadius: circle ? "50%" : "initial"
    };
    if (checked && !circle) {
      styles["&:before"] = {
        position: "absolute",
        display: "table",
        border: "2px solid #fff",
        borderTop: 0,
        borderLeft: 0,
        transform: "rotate(45deg) scale(1) translate(-50%,-50%)",
        transition: "all .2s cubic-bezier(.12,.4,.29,1.46) .1s",
        content: '" "',
        top: "44%",
        left: "50%",
        width: "5px",
        height: "9px",
        transformOrigin: "left top"
      };
    }
  }
  return styles;
});
const Checkbox = (_a) => {
  var _b = _a, {
    className,
    width = "0.9rem",
    height = "0.9rem"
  } = _b, rest = __objRest(_b, [
    "className",
    "width",
    "height"
  ]);
  return /* @__PURE__ */ React.createElement(StyledCheckbox, __spreadProps(__spreadValues({
    width,
    height
  }, rest), {
    className
  }));
};

export { Checkbox };
